import { textHelpers } from '@/utils/tools'
import { TypeRefFragment } from '@/gql/graphql'

export const fieldToReadAble = (str: string | undefined): string =>
  str ? textHelpers.capitalizeFirstLetter(textHelpers.keyToHumanReadable(str)) : ''

// Helper function to get the innermost type of field (unwrapping non-null and list types)
export const getFieldTypeLeaf = (type: TypeRefFragment): TypeRefFragment => {
  // Unwrap the type until there is no more 'ofType'
  while (type?.ofType) {
    type = type.ofType
  }

  return type
}

export const convertArgTypeToTypeStr = (argType) => {
  switch (argType.kind) {
    case 'LIST':
      return `[${convertArgTypeToTypeStr(argType.ofType)}]`
    case 'NON_NULL':
      return `${convertArgTypeToTypeStr(argType.ofType)}!`
  }
  return argType.name
}
